import { ReactElement } from "react";
import { useQueryParams } from "../../../hooks/useQueryParams";

interface PreviewModeGuardProps {
    children: ReactElement | false;
}

/** Determines if the custom reports page is in preview mode */
export const usePreviewMode = () => {
    const query = useQueryParams();

    return query.get("preview") === "true";
};

/** Renders the `{children}` component only if user is not in Custom Reports preview mode */
export const PreviewModeGuard = ({ children }: PreviewModeGuardProps) => {
    const isPreviewMode = usePreviewMode();

    if (isPreviewMode || !children) {
        return null;
    }

    return children;
};
